import { Component } from '@angular/core';

@Component({
  selector: 'app-metadata-editor',
  templateUrl: './metadata-editor.component.html',
  styleUrls: ['./metadata-editor.component.scss'],
  standalone: false,
})
export class MetadataEditorComponent {
  constructor() {}
}
